import { COLORS } from '@btime/constants'
import { capitalizeIfLower } from '@btime/helpers'
import React from 'react'

import { HorizontalLine } from '../../../../components/shapes/Line'
import Accordion from '../../../../components/structure/Accordion'
import DynamicListCounters from '../DynamicListCounters'
import DynamicPresentationCard from '../../DynamicPresentationCard'
import FlexGrid from '../../../../components/structure/FlexGrid'
import LazyLoad from '../../../../components/helpers/LazyLoad'

const Category = ({ item, startsOpen, hideCategories }) => {
  const content = (
    <FlexGrid direction="column" align="stretch" gutter={0.5}>
      {item.replies.map(reply => (
        <LazyLoad key={reply.id}>
          <DynamicPresentationCard reply={reply} />
        </LazyLoad>
      ))}
    </FlexGrid>
  )

  if (hideCategories) return <LazyLoad>{content}</LazyLoad>

  return (
    <LazyLoad>
      <Accordion
        label={capitalizeIfLower(item.name)}
        startsOpen
        noPanel
        sticky
        side={<DynamicListCounters replies={item.replies} />}
      >
        {content}
      </Accordion>

      <HorizontalLine thin lineColor={COLORS.light3} />
    </LazyLoad>
  )
}

export default Category
